<template>
  <section class="quote-document-info">
    <div class="form-item">
      <span>Policyholder HKID</span>
      <file-container :fileData="formData.id_type_pic" />
    </div>
    <div
      v-if="formData.info_opera_list && formData.info_opera_list.length > 0"
    >
      <div
        v-for="(item,index) in formData.info_opera_list"
        :key="index"
        class="form-item">
        <span>Operator  {{index+1}}</span>
        <file-container
          :key="index"
          :fileData="{
            url:item.opera_id_type_pic_url,
            thumb_url:item.opera_id_type_pic_thumb_url,
            client_name:item.opera_licence_pic_path_id}"
        />
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'DroneDocumentInfo',
  props: {
    formData: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
